<script>
import { Navigation, Pagination, A11y } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/svelte';
import {fade, fly} from 'svelte/transition'
import {push, pop, replace} from 'svelte-spa-router'
import {Button, Form, TextInput, Select, SelectItem, Checkbox, DatePicker, DatePickerInput} from 'carbon-components-svelte';
import OtpInput from 'svelte-otp'
import {getUserData} from '../userdata.js'

import {Motion, M} from 'svelte-motion'
import { getAuth, signInWithPhoneNumber, RecaptchaVerifier } from "firebase/auth";
import {itemB} from './animations.js'
import Tailwindcss from '../Tailwind.svelte'
import {animateScroll} from 'svelte-scrollto-element'
import { registerUser } from '../auth';
import {getCountries}  from '../userdata'
import {_} from 'svelte-i18n'
import {auth} from '../firebase.js'
/* import {itemB} from './animations' */
import {sessionData} from '../stores'
import { onMount } from 'svelte';


export let selected
export let handleClick
export let allowed
let timeUntilRefill = '';

function updateTimeUntilRefill() {
  const now = new Date();
  const nextRefill = new Date(Date.UTC(now.getUTCFullYear(), now.getUTCMonth(), now.getUTCDate() + 1));
  const diff = nextRefill - now;
  const hours = Math.floor(diff / (1000 * 60 * 60));
  const minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
  const seconds = Math.floor((diff % (1000 * 60)) / 1000);
  timeUntilRefill = `${hours.toString().padStart(2,'0')}:${minutes.toString().padStart(2,'0')}:${seconds.toString().padStart(2,'0')}`;
}

onMount(() => {
  updateTimeUntilRefill();
  const interval = setInterval(updateTimeUntilRefill, 1000);
  return () => clearInterval(interval);
});
</script>



<Tailwindcss/>
<button class="{selected ? 'play-button-active' : 'play-button-inactive'} {(!allowed || $sessionData.geoCountry == 'DE' || ($sessionData.puzzleCredits < 1 && $sessionData.selectedCard === 'puzzle')) ? 'not-allowed' : ''}" in:fade out:fly={{x: -20}} on:click={() => {if (allowed && $sessionData.geoCountry !== 'DE' && ($sessionData.selectedCard !== 'puzzle' || $sessionData.puzzleCredits > 0)) handleClick()}}>
  {#if $sessionData.geoCountry == "DE"}
    <p class="text-gray-500 text-sm font-autoscape">$_('puzzle.unavailableInYourRegion')</p>
  {:else}
    <h2 class="mx-auto text-black">
      {$sessionData.selectedCard === 'puzzle' ? $_('puzzle.begin') : $_('gameplay.play')}
    </h2>
    {#if $sessionData.selectedCard === 'puzzle'}
      {#if $sessionData.puzzleCredits > 0}
        <p class="text-gray-500 text-sm font-autoscape">{$_('puzzle.creditsLeft')}: {$sessionData.puzzleCredits}</p>
      {:else}
        <p class="text-gray-500 text-sm font-autoscape">{$_('puzzle.refillIn')} {timeUntilRefill}</p>
    {/if}
    {/if}
  {/if}
</button>
<style scoped>
.not-allowed{
  background-color: gray !important;
  cursor: not-allowed;
}

.play-button-active{

  opacity: 1;
  transform: translateY(0px);

  position: absolute;
  box-shadow: 0rem 0 1rem #000;
  transition-delay: 3s;
  transition: 0.5s;
  bottom: 0px;
  left: -25%;
  height: 4.5rem;
  width: 150%;

  /* background-color: #212229; */
  background-color: #FAE264;

  font-size: 2rem;
  color: white;
  /* margin: auto; */

  /* background-color: yellow; */

}


.play-button-inactive{

  opacity: 1;
  transform: translateY(7rem);
  transition: 0.5s;
  position: absolute;
  bottom: 0px;
  left: 0px;
  height: 4.5rem;
  width: 100%;
  background-color: #212229;

  font-size: 2rem;
  color: white;
  /* margin: auto; */

  /* background-color: yellow; */

}
</style>
